export default __webpack_public_path__ + "static/media/community.02797682.png";